export const getBadgeClassname = (provider: string): string | undefined => {
  if (provider === "sls") return "badge slsbadge";
  if (provider === "frnsw") return "badge bg-success";
  if (provider === "uts") return "badge bg-warning text-dark";
  return;
};
